/**
 * Generated from RobotScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function RobotScreenLayout(this: $RobotScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	const buttons = this.buttons;
	$(buttons, 0, headButton, {x:-1025, y:-282.75, w:410.00, h: 293.00});
	$(buttons, 1, bodyButton, {x:1025, y:-285.15, w:413.00, h: 307.00});
	$(buttons, 2, leftArmButton, {x:-1025, y:22.35, w:410.00, h: 294.00});
	$(buttons, 3, rightArmButton, {x:1025, y:20.35, w:413.00, h: 284.00});
	$(buttons, 4, leftLegButton, {x:-1025, y:333.45, w:410.00, h: 316.00});
	$(buttons, 5, rightLegButton, {x:1025, y:324.45, w:413.00, h: 298.00});
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "assembly", assembly, {x:-11.1, y:-30.1, sx:0.880, sy:0.880});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("package-metal.jpg", 0.000, 0.000);
	return this;
}
export function assembly(this: $assembly) {
	const lleg = this.lleg;
	$(lleg, 0, itemLeg1, {x:-156.8, y:221.9, w:343.00, h: 690.00});
	$(lleg, 1, itemLeg2, {x:-106.4, y:221.5, w:292.00, h: 640.00});
	$(lleg, 2, itemLeg3, {x:-117.15, y:223.05, w:333.00, h: 652.00});
	$(lleg, 3, itemLeg4, {x:-93.35, y:231.9, w:376.00, h: 650.00});
	$(lleg, 4, itemLeg5, {x:-122.7, y:232.1, w:397.00, h: 713.00});
	const rleg = this.rleg;
	$(rleg, 0, itemLeg1, {x:165.45, y:222.5, w:-343.00, h: 690.00});
	$(rleg, 1, itemLeg2, {x:116.2, y:221.5, w:-292.00, h: 640.00});
	$(rleg, 2, itemLeg3, {x:126.6, y:223.35, w:-333.00, h: 652.00});
	$(rleg, 3, itemLeg4, {x:90.35, y:231.6, w:-376.00, h: 650.00});
	$(rleg, 4, itemLeg5, {x:108.35, y:232.1, w:-397.00, h: 713.00});
	const larm = this.larm;
	$(larm, 0, itemArm1, {x:-278.75, y:-200.3, w:414.00, h: 712.00});
	$(larm, 1, itemArm2, {x:-220.45, y:-201.8, w:439.00, h: 638.00});
	$(larm, 2, itemArm3, {x:-252.3, y:-199.75, w:495.00, h: 675.00});
	$(larm, 3, itemArm4, {x:-195.65, y:-200.25, w:367.00, h: 653.00});
	$(larm, 4, itemArm5, {x:-219.25, y:-200.2, w:482.00, h: 981.00});
	const rarm = this.rarm;
	$(rarm, 0, itemArm1, {x:278.15, y:-200.95, w:-414.00, h: 712.00});
	$(rarm, 1, itemArm2, {x:216.2, y:-201.8, w:-439.00, h: 638.00});
	$(rarm, 2, itemArm3, {x:243.2, y:-199.85, w:-495.00, h: 675.00});
	$(rarm, 3, itemArm4, {x:196.65, y:-201.1, w:-367.00, h: 653.00});
	$(rarm, 4, itemArm5, {x:206.8, y:-200.3, w:-482.00, h: 981.00});
	const body = this.body;
	$(body, 0, itemBody1, {x:0.7, y:-39.9, w:796.00, h: 696.00});
	$(body, 1, itemBody2, {x:-2.55, y:-43.05, w:499.00, h: 622.00});
	$(body, 2, itemBody3, {x:-4.3, y:-52.5, w:538.00, h: 632.00});
	$(body, 3, itemBody4, {x:0, y:0, w:431.00, h: 685.00});
	$(body, 4, itemBody5, {x:-6.45, y:-7.15, w:525.00, h: 710.00});
	const head = this.head;
	$(head, 0, itemHead1, {x:-5.15, y:-298.7, w:479.00, h: 359.00});
	$(head, 1, itemHead2, {x:-3.5, y:-330.3, w:350.00, h: 431.00});
	$(head, 2, itemHead3, {x:-2.5, y:-348.5, w:364.00, h: 452.00});
	$(head, 3, itemHead4, {x:1.75, y:-338.15, w:619.00, h: 350.00});
	$(head, 4, itemHead5, {x:-11.35, y:-337.25, w:403.00, h: 418.00});
	$(head, 5, itemHead6, {x:6.25, y:-313.4, w:494.00, h: 570.00});
	return this;
}
function itemLeg1(this: $itemLeg1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-leg-1.png", 0.778, 0.084);
	return this;
}
function itemLeg2(this: $itemLeg2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-leg-2.png", 0.747, 0.055);
	return this;
}
function itemLeg3(this: $itemLeg3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-leg-3.png", 0.817, 0.064);
	return this;
}
function itemLeg4(this: $itemLeg4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-leg-4.png", 0.793, 0.140);
	return this;
}
function itemLeg5(this: $itemLeg5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-leg-5.png", 0.786, 0.105);
	return this;
}
function itemArm1(this: $itemArm1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-arm-1.png", 0.872, 0.135);
	return this;
}
function itemArm2(this: $itemArm2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-arm-2.png", 0.872, 0.152);
	return this;
}
function itemArm3(this: $itemArm3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-arm-3.png", 0.812, 0.132);
	return this;
}
function itemArm4(this: $itemArm4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-arm-4.png", 0.785, 0.138);
	return this;
}
function itemArm5(this: $itemArm5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-arm-5.png", 0.822, 0.319);
	return this;
}
function itemBody1(this: $itemBody1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-body-1.png", 0.500, 0.500);
	return this;
}
function itemBody2(this: $itemBody2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-body-2.png", 0.500, 0.500);
	return this;
}
function itemBody3(this: $itemBody3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-body-3.png", 0.500, 0.500);
	return this;
}
function itemBody4(this: $itemBody4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-body-4.png", 0.500, 0.500);
	return this;
}
function itemBody5(this: $itemBody5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-body-5.png", 0.500, 0.500);
	return this;
}
function itemHead1(this: $itemHead1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-head-1.png", 0.497, 0.911);
	return this;
}
function itemHead2(this: $itemHead2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-head-2.png", 0.511, 0.965);
	return this;
}
function itemHead3(this: $itemHead3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-head-3.png", 0.508, 0.962);
	return this;
}
function itemHead4(this: $itemHead4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-head-4.png", 0.514, 0.934);
	return this;
}
function itemHead5(this: $itemHead5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-head-5.png", 0.501, 0.883);
	return this;
}
function itemHead6(this: $itemHead6) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-head-6.png", 0.518, 0.858);
	return this;
}
function rightLegButton(this: $rightLegButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("right-leg-button.png", 1.000, 0.500);
	return this;
}
function rightArmButton(this: $rightArmButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("right-arm-button.png", 1.000, 0.500);
	return this;
}
function leftLegButton(this: $leftLegButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("left-leg-button.png", 0.000, 0.500);
	return this;
}
function leftArmButton(this: $leftArmButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("left-arm-button.png", 0.000, 0.500);
	return this;
}
function headButton(this: $headButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("head-button.png", 0.000, 0.502);
	return this;
}
function bodyButton(this: $bodyButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("body-button.png", 1.000, 0.502);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $RobotScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly buttons: $$array<$headButton|$bodyButton|$leftArmButton|$rightArmButton|$leftLegButton|$rightLegButton>;
	readonly background: $background;
	readonly assembly: $assembly;
}
interface $background extends $$sprite {
}
interface $assembly extends $$container {
	readonly lleg: $$array<$itemLeg1|$itemLeg2|$itemLeg3|$itemLeg4|$itemLeg5>;
	readonly rleg: $$array<$itemLeg1|$itemLeg2|$itemLeg3|$itemLeg4|$itemLeg5>;
	readonly larm: $$array<$itemArm1|$itemArm2|$itemArm3|$itemArm4|$itemArm5>;
	readonly rarm: $$array<$itemArm1|$itemArm2|$itemArm3|$itemArm4|$itemArm5>;
	readonly body: $$array<$itemBody1|$itemBody2|$itemBody3|$itemBody4|$itemBody5>;
	readonly head: $$array<$itemHead1|$itemHead2|$itemHead3|$itemHead4|$itemHead5|$itemHead6>;
}
interface $itemLeg1 extends $$sprite {
}
interface $itemLeg2 extends $$sprite {
}
interface $itemLeg3 extends $$sprite {
}
interface $itemLeg4 extends $$sprite {
}
interface $itemLeg5 extends $$sprite {
}
interface $itemArm1 extends $$sprite {
}
interface $itemArm2 extends $$sprite {
}
interface $itemArm3 extends $$sprite {
}
interface $itemArm4 extends $$sprite {
}
interface $itemArm5 extends $$sprite {
}
interface $itemBody1 extends $$sprite {
}
interface $itemBody2 extends $$sprite {
}
interface $itemBody3 extends $$sprite {
}
interface $itemBody4 extends $$sprite {
}
interface $itemBody5 extends $$sprite {
}
interface $itemHead1 extends $$sprite {
}
interface $itemHead2 extends $$sprite {
}
interface $itemHead3 extends $$sprite {
}
interface $itemHead4 extends $$sprite {
}
interface $itemHead5 extends $$sprite {
}
interface $itemHead6 extends $$sprite {
}
interface $rightLegButton extends $$sprite {
}
interface $rightArmButton extends $$sprite {
}
interface $leftLegButton extends $$sprite {
}
interface $leftArmButton extends $$sprite {
}
interface $headButton extends $$sprite {
}
interface $bodyButton extends $$sprite {
}
